export default "__VITE_ASSET__D6Kbyo_y__"